import React from 'react';
import ContactForm from './contact-form.component';
import './contact.styles.scss';

const Contact = () => {
  return (
    <div className="contact-container">
      <section className="contact-hero">
        <div className="container">
          <h1>Contact Rmt-DBA</h1>
          <p>Connect with our AI-powered IT specialists to accelerate your digital transformation</p>
        </div>
      </section>

      <section className="contact-content">
        <div className="container">
          <ContactForm />
        </div>
      </section>
    </div>
  );
};

export default Contact;
